import { ModalEvent } from 'kinetic-angular';
import { UploadFileLabels } from '../components/business-account-request';
import { ApiResponse } from '../definitions/api-response.interface';

export const mockUploadFileAemResponse: UploadFileLabels = {
	heading: 'Upload Location List',
	subHeading: 'Please be sure the AdminGRID location is included in the Excel upload and matches the AdminGRID listed on the Dashboard before you click \"Upload\".',
	modelButtons: { close: 'Close', cancel: 'Cancel', upload: 'Upload' },
	closeIcon: { iconPath: '', altText: '' },
	uploadFile: {
		onLoadIcon: { iconPath: '', altText: '' },
		errorIcon: { iconPath: '', altText: '' },
		successIcon: { iconPath: '', altText: '' },
		dragDropLabel: 'Drag and Drop',
		orLabel: 'or',
		uploadButtons: { chooseFile: 'Choose File', replaceFile: 'Replace File', tryAgain: 'Try Again' },
		success: 'Uploaded Submitted'
	}
};

export const mockFile1: File = {
	name: 'BusninessRequestAccount.csv',
	size: 10423,
	type: 'text/csv'
} as unknown as File;

export const mockFile2: File = {
	name: 'Corporate_Admin_New Locations_List2.xlsx',
	size: 1000023,
	type: 'application/vnd.openxmlformats-officedocument.spreadsheetml'
} as unknown as File;

export const mockFile3: File = {
	name: 'Corporate_Admin_New Locations_List2.xlsx',
	size: 10423,
	type: 'application/vnd.openxmlformats-officedocument.spreadsheetml'
} as unknown as File;

export const mockEvent: ModalEvent = {
	state: {
		hidden: false,
		label: 'Upload New Locations List',
		buttons: [
			{ label: 'Cancel', disabled: false, cssClass: 'btn-secondary' },
			{ label: 'Upload', disabled: false, cssClass: 'btn-black' }
		],
		cssClass: 'uploadFileTitle'
	},
	cta: { label: '', disabled: false, cssClass: 'btn-black' }  
};

export const mockApiFailure: ApiResponse = {
	success: false,
	statusCode: 403,
	message: 'File should be less than 100 MB and should be in xlsx/csv format',
	data: {}
};

export const mockWrongFormat: ApiResponse = {
	success: false,
	statusCode: 400,
	message: 'Please ensure the data in the file is in the correct format and try again, and at a minimum the Primary GRID must be entered',
	data: {}
};
